// This file is auto-generated

import deAT from './universalat/de-AT.json';

const messages = { 'de-AT': deAT };

export default messages;
